import React from 'react';
import styled from '@emotion/styled';
import { Icon as BaseIcon } from 'components/Icon/Icon';
import facebookIcon from './facebook.svg';
import linkedInIcon from './linkedin.svg';
import twitterIcon from './twitter.svg';
import { Link } from 'components/Link/Link';

const Outer = styled.div`
  display: grid;
  justify-content: center;
  grid-template-columns: 20px 20px 20px;
  grid-column-gap: 20px;
`;

const Icon = styled(BaseIcon)`
  display: inline-block;
  height: 20px;
  width: 20px;
`;

export const ArticleHeroSocialIcons = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <Outer className={className}>
      <Link href="https://facebook.com/ZapierApp/">
        <Icon svg={facebookIcon} />
      </Link>
      <Link href="https://twitter.com/zapier">
        <Icon svg={twitterIcon} />
      </Link>
      <Link href="https://linkedin.com/company/zapier">
        <Icon svg={linkedInIcon} />
      </Link>
    </Outer>
  );
};
